import { mergeObjects } from '@hrlogics/helper-utils';

import { SELECT_ALL_OPTION } from '@clearverify/constants';

import { type EmailActivityQueryVariables } from 'src/api';

import { type EmailTrackerTableFilters } from '../types';

export const prepareFilters = (
  filters: EmailTrackerTableFilters,
): Pick<EmailActivityQueryVariables, 'toEmailFilter' | 'statusFilter'> => {
  const { toEmail, status } = filters;

  const toEmailFilter: EmailActivityQueryVariables = {
    toEmailFilter: toEmail,
  };

  const statusFilter: EmailActivityQueryVariables =
    status && status !== SELECT_ALL_OPTION.value
      ? {
          statusFilter: status,
        }
      : {};

  return mergeObjects(toEmailFilter, statusFilter);
};
